import { useEffect, useState } from 'react';
import { PLATE_TRANSPARENCY_LIMITS, presentationAppearance } from '../../../renderer/src/presentation-appearance';
import type { VideoPresentation } from '../../../renderer/src/video-presentation';
import { CompactRangeControl } from './CompactRangeControl';

export type AppearanceChange = { plateTransparency: number } | { textColor: string };
export function PresentationAppearanceControls({ value, onChange }: {
  value: VideoPresentation; onChange: (change: AppearanceChange) => void;
}) {
  const appearance = presentationAppearance(value);
  const [hex, setHex] = useState(appearance.textColor);
  useEffect(() => setHex(appearance.textColor), [appearance.textColor]);
  const valid = /^#[0-9a-f]{6}$/i.test(hex);
  return <>
    <CompactRangeControl label="Plate transparency" value={appearance.plateTransparency} unit="%"
      integer invalidMessage="Enter a whole percentage from 0 to 100. The last valid value remains active."
      min={PLATE_TRANSPARENCY_LIMITS.min} max={PLATE_TRANSPARENCY_LIMITS.max}
      onChange={plateTransparency => onChange({ plateTransparency })} />
    <p className="composer-hint">0% solid black · 100% transparent. Text stays opaque.</p>
    <label>Information text color<div className="presentation-color">
      <input aria-label="Information text color" type="color" value={appearance.textColor}
        onChange={event => onChange({ textColor: event.target.value })} />
      <input aria-label="Information text hex" value={hex} type="text" pattern="#[0-9a-fA-F]{6}" maxLength={7}
        aria-invalid={!valid} onChange={event => {
          setHex(event.target.value);
          if (/^#[0-9a-f]{6}$/i.test(event.target.value)) onChange({ textColor: event.target.value.toLowerCase() });
        }} />
    </div></label>
    {!valid && <p role="status" className="composer-hint">Enter a six-digit hex color, such as #ffffff. The last valid color remains active.</p>}
  </>;
}
